import React, { useEffect, useRef, useState } from "react";

import { GenericTable, Input, toastMessage, Button, tCell, ActionMenu, Dialog, Dropdown, ConfirmationDialog } from "../utils/index";
import { buttonClasses } from "../utils/theme";
import { useOrgs, usePlant, useSuppliers, useUserDetail, useUserPermissions } from "../../services/hooks";
import { fakeFileInput, formatDate, isObjectEqual } from "../../services/functions";
import { useAddSupplierMutation, useDeleteSupplierMutation, useUpdateSupplierMutation, useUploadBulkSupplierMutation } from "../../api/vmsSlice";
import { Navigate } from "react-router-dom/dist";
import Genericfilter from "../utils/Genericfilter";
import { debounce } from "../../services/functions";
import { Grid } from "@mui/material";
import { GenericstatsV2 } from "../utils/Genericstats";
import CommonTour, { TourIcon } from "../Tour/CommonTour";
import { usePlantContext } from "../../context/plantContext";
const dummyTourData = [
	{
		_id: "67fe40941a54c181c24cc5be",
		supplierName: "Los Pollos Hermanos",
		supplierId: "420",
		prefix: "",
		orgId: "65af5e42b41c7ab7ed1119ff",
		orgName: "LVMH",
		created_by: {
			user_id: "632c5cd8a62a978fd33d4b8c",
			user_type: "superAdmin",
			name: "Shubham",
			email: "shubham.a@lynkit.in",
		},
		created_on: "2025-04-15T11:18:44.093Z",
		modified_by: {
			user_id: "632c5cd8a62a978fd33d4b8c",
			user_type: "superAdmin",
			name: "Shubham",
			email: "shubham.a@lynkit.in",
		},
		modified_on: "2025-04-15T11:18:44.093Z",
		__v: 0,
	},
];
const SupplierManagementTour = [
	{
		target: ".title",
		content: "Welcome to Supplier Management! Here you can manage all your suppliers and their information.",
		placement: "bottom",
	},
	{
		target: ".genericStats-containter",
		content: "These cards provide an overview of your supplier statistics at a glance.",
		placement: "bottom",
	},
	{
		target: "#Genericfilter",
		content: "Filter suppliers by name, ID, or organization to find specific entries quickly.",
		placement: "bottom",
	},
	{
		target: ".addSupplier",
		content: "Create new supplier records individually using this button.",
		placement: "left",
	},
	{
		target: ".bulkUpload",
		content: "Upload multiple suppliers at once using an Excel template.",
		placement: "left",
	},
	{
		target: ".downloadSample",
		content: "Download the Excel template to ensure proper formatting for bulk uploads.",
		placement: "left",
	},
	{
		target: ".main_content",
		content: "This table lists all your suppliers with their IDs and creation dates.",
		placement: "top",
	},
	{
		target: ".actionMenu",
		content: "Edit existing suppliers or manage their information using these action buttons.",
		placement: "left",
		condition: () => !!document.querySelector(".ActionMenu"),
	},
];
const SAMPLE_EXCEL_PATH = "/sample_excels/supplier_sample.xlsx";
const EXCEL_TYPE = "supplier";

const defaultFilter = {
	pagesize: 10,
	page_no: 1,
};

const SupplierManagement = () => {
	const { userPermissions, isFetched } = useUserPermissions();
	const { plantId } = usePlantContext();
	const { userDetail, isSuperAdmin } = useUserDetail();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;

	const tourRef = useRef();
	const [isTourMode, setIsTourMode] = useState(false);
	const shouldRunTour = !userDetail?.moduleTour?.suppliers;
	const { orgOptions } = useOrgs({}, { skip: !isSuperAdmin });
	const { plantOptions, getPlantDetails, clearPlants } = usePlant();
	useEffect(() => {
		if (userPermissions?.managePlant?.value) {
			getPlantDetails({});
		}
	}, [userPermissions]);
	const [isModal, setIsModal] = useState(false);
	const [fetchStats, setFetchStats] = useState(false);
	const onModalOpen = () => setIsModal(true);
	const onModalClose = () => {
		setIsModal(false);
		if (updateDataRef.current) {
			updateDataRef.current = null;
		}
	};

	const updateDataRef = useRef(null);
	const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
	const [supplierToDelete, setSupplierToDelete] = useState(null);
	const filterFields = [
		{
			inputType: "textfield",
			id: "1",
			name: "supplierName",
			type: "text",
			label: "Supplier Name",
			placeholder: "Supplier Name",
			readOnly: false,
			error: "",
			value: "",
		},
		{
			inputType: "textfield",
			id: "2",
			name: "supplierId",
			type: "text",
			label: "Supplier id",
			placeholder: "Supplier id",
			readOnly: false,
			error: "",
			value: "",
		},
	];
	if (userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "orgId",
			name: "orgId",
			label: "Organization",
			error: "",
			option: orgOptions,
		});
	}
	if (shouldHandlePlant && userDetail?.userType == "superAdmin") {
		filterFields.push({
			inputType: "dropdown",
			id: "plantIds",
			name: "plantIds",
			label: "Warehouse",
			error: "",
			option: plantOptions,
		});
	}
	const filterRef = useRef(defaultFilter);
	if (userDetail.userType !== "superAdmin") {
		filterRef.current.plantIds = plantId;
	}
	const { page_no, pagesize } = filterRef.current;
	const { suppliers, count, isLoading, getSuppliers } = useSuppliers(userDetail.userType === "superAdmin" ? filterRef.current : null);
	useEffect(() => {
		if (filterRef.current && userDetail?.userType !== "superAdmin") {
			getSuppliers(filterRef.current);
		}
	}, [plantId]);
	const [handleDelete] = useDeleteSupplierMutation();

	let actionHandlers = {};
	if (userPermissions?.updateProductCategory?.value) {
		actionHandlers.edit = (id) => {
			updateDataRef.current = suppliers[id];
			setIsModal(true);
		};
	}
	if (userPermissions?.deleteProductCategory?.value) {
		actionHandlers.delete = async (id) => {
			setDeleteConfirmOpen(true);
			setSupplierToDelete(suppliers[id]);
		};
	}

	const handleDeleteConfirm = async () => {
		if (!supplierToDelete) return;

		const payload = { deleteId: supplierToDelete._id };
		const {
			data: { error, message },
		} = await handleDelete(payload);

		if (error) {
			toastMessage(false, message);
		} else {
			onUpdateSuccess();
			toastMessage(true, message);
		}
		setDeleteConfirmOpen(false);
		setSupplierToDelete(null);
	};

	const handleDeleteCancel = () => {
		setDeleteConfirmOpen(false);
		setSupplierToDelete(null);
	};

	let header = ["S.no", "Supplier Name", "Supplier Id", "Created On"];
	if (userDetail?.userType == "superAdmin") {
		header.push("Org Name");
	}
	if (userPermissions?.updateSupplier?.value || userPermissions?.deleteSupplier?.value) {
		header.push("Action");
	}

	const rows =
		(shouldRunTour || isTourMode ? dummyTourData : suppliers)?.map((d, i) => {
			let row = [];
			row.push(tCell((page_no - 1) * pagesize + i + 1), tCell(d.supplierName), tCell(d.supplierId), tCell(formatDate(d.created_on)));

			if (userDetail?.userType == "superAdmin") {
				row.push(tCell(d.orgName));
			}
			if (userPermissions?.updateSupplier?.value || userPermissions?.deleteSupplier?.value) {
				row.push(
					<div style={{ paddingLeft: "0.5rem" }}>
						<ActionMenu id={i} handlers={actionHandlers} />
					</div>
				);
			}

			return row;
		}) || [];

	const onPageChange = (page_no) => {
		filterRef.current = { ...filterRef.current, page_no: page_no + 1 };
		getSuppliers(filterRef.current);
	};
	const onPageSizeChange = (e) => {
		const { value } = e.target;
		filterRef.current = { ...filterRef.current, pagesize: value };
		getSuppliers(filterRef.current);
	};
	const onUpdateSuccess = () => {
		getSuppliers(filterRef.current);
		setFetchStats((old) => !old);
	};
	const [handleUploadExcel] = useUploadBulkSupplierMutation();
	const onBulkExcelUpload = () => {
		fakeFileInput(async (formData) => {
			formData.append("type", EXCEL_TYPE);
			formData.append("plantId", plantId);
			const {
				data: { error, message },
			} = await handleUploadExcel(formData);
			if (error) {
				toastMessage(false, message);
			} else {
				toastMessage(true, message);
				onUpdateSuccess();
			}
		});
	};

	/**
	 * We use GenericFilter component for all CRUD filters. That component maintains its own state for the filter
	 * and that object is sent here to the handleFilterChange function.
	 * Mutating this _filter object will cause the filter state to change on rerender (It's probably because of object reference in JS. The filter object from the state gets mutated and then the component gets re-rendered  due to any reason and now the state will have the mutated object)
	 * Here we have relationship between Org and Plant. On selecting an org, we will fetch its plant. So in order to clear previous selected plant when selecting different org, we will mutate the _filter object
	 */
	const handleFilterChange = (_filter) => {
		let filter = { ..._filter };

		for (let key in filter) {
			if (!filter[key]) delete filter[key];
		}
		if (userDetail?.userType == "superAdmin") {
			if (filter.orgId) {
				// filter.orgId = filter.orgId?.value;
				if (shouldHandlePlant && filter.orgId != filterRef.current.orgId) {
					// when switching organization, we want to
					// - get plants for that org
					// - clear plantIds from the local filter object
					// - clear plantIds from original filter object, mutating the state and clearing the plant dropdown
					delete filter.plantIds;
					delete _filter.plantIds;
					getPlantDetails({ orgId: filter.orgId });
				}
			} else {
				clearPlants();
			}
		}
		// if (filter.plantIds) filter.plantIds = filter.plantIds?.value;

		filter.page_no = 1;
		filter.pagesize = 10;

		if (!isObjectEqual(filterRef.current, filter)) {
			filterRef.current = { ...filter };
			getSuppliers(filterRef.current);
		}
	};

	const handleTourStart = () => {
		setIsTourMode(true);
		tourRef.current?.restartTour();
	};
	if (isFetched && userPermissions && Object.keys(userPermissions).length && !userPermissions.getSupplier?.value) return <Navigate to="/not-authorized" replace />;

	return (
		<div className="contentpanel">
			<CommonTour ref={tourRef} steps={SupplierManagementTour} moduleName="suppliers" onTourComplete={() => setIsTourMode(false)} />
			<Grid container spacing="0.5rem">
				<Grid item xl={6} lg={6} md={5} sm={12} xs={12}>
					<h1 className="title">
						Supplier Management
						<span title="Replay Tour" onClick={handleTourStart} style={{ cursor: "pointer" }}>
							<TourIcon />
						</span>
					</h1>
				</Grid>
				<Grid item xl={6} lg={6} md={7} sm={12} xs={12}>
					<Grid container spacing="0.5rem">
						{userPermissions?.addSupplier?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="addSupplier">
								<Button onClick={onModalOpen} text="Add Supplier" style={buttonClasses.lynkitOrangeEmpty} />
							</Grid>
						) : null}
						{userPermissions?.addSupplier?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="bulkUpload">
								<Button onClick={onBulkExcelUpload} text="Bulk Upload" style={buttonClasses.lynkitOrangeFill} />
							</Grid>
						) : null}
						{userPermissions?.addSupplier?.value ? (
							<Grid item xl={4} lg={4} md={4} sm={4} xs={12} className="downloadSample">
								<a href={SAMPLE_EXCEL_PATH} download>
									<Button text="Download Sample" style={buttonClasses.lynkitBlackFill} />
								</a>
							</Grid>
						) : null}
					</Grid>
				</Grid>
			</Grid>

			<hr className="bgg" />
			<GenericstatsV2 statsFor={"supplier"} fetchStats={fetchStats} plantId={plantId} />
			<Genericfilter filterFields={filterFields} onFilterChange={debounce((filter) => handleFilterChange(filter), 500)} addOnClear />
			<div className="main_content">
				<GenericTable
					header={header}
					rows={rows}
					pageCount={count || suppliers?.length}
					pageNo={filterRef.current?.page_no}
					limit={filterRef.current?.pagesize}
					onPageChange={onPageChange}
					onPageSizeChange={onPageSizeChange}
					isLoading={isLoading}
				/>
			</div>

			{isModal && <AddSupplier open={isModal} onClose={onModalClose} updateData={updateDataRef.current} onUpdateSuccess={onUpdateSuccess} />}
			<ConfirmationDialog open={deleteConfirmOpen} handleClose={handleDeleteCancel} handleSubmit={handleDeleteConfirm} title="Delete Supplier" submitText="Delete">
				Are you sure you want to delete this supplier? This action cannot be undone.
			</ConfirmationDialog>
		</div>
	);
};

export default SupplierManagement;

const defaultForm = {
	supplierName: "",
	supplierId: "",
	updateId: undefined, //_id for update case
	orgId: undefined,
	plantId: "",
	prefix: "",
};

function fillUpdateData(data) {
	return {
		supplierName: data.supplierName,
		supplierId: data.supplierId,
		updateId: data._id,
		orgId: data.orgId,
		plantId: data.plantId || "",
		prefix: data.prefix || "",
	};
}

function AddSupplier({ onClose, open, updateData, onUpdateSuccess }) {
	const [formData, setFormData] = useState(updateData ? fillUpdateData(updateData) : defaultForm);
	const [error, setError] = useState({});
	const { userDetail, isSuperAdmin } = useUserDetail();
	const { userPermissions } = useUserPermissions();
	const { plantId } = usePlantContext();
	const shouldHandlePlant = userDetail?.userType == "superAdmin" || userPermissions?.managePlant?.value;

	const { orgOptions } = useOrgs({}, { skip: !isSuperAdmin });
	const orgValue = orgOptions.find((_) => _.value == formData.orgId);

	const { plantOptions, clearPlants, getPlantDetails } = usePlant();
	const plantValue = plantOptions.find((_) => formData.plantId == _.value);
	useEffect(() => {
		if (userPermissions?.managePlant?.value) {
			getPlantDetails({});
		}
	}, [userPermissions]);
	const handleInput = (e) => {
		const { name, value } = e.target;
		setFormData({ ...formData, [name]: value });
	};
	const onDropdownChange = (option, name) => {
		let value = Array.isArray(option) ? option.map((_) => _.value) : option?.value || "";

		handleInput({ target: { name, value } });

		if (name == "orgId" && shouldHandlePlant) {
			if (value) {
				getPlantDetails({ orgId: value });
			} else {
				clearPlants();
			}
		}
	};

	const [handleAdd, { isLoading: isAdding }] = useAddSupplierMutation();
	const [handleUpdate, { isLoading: isUpdating }] = useUpdateSupplierMutation();
	const handleFormSubmit = async () => {
		const payload = { ...formData, orgName: orgValue?.label, plantId: userDetail?.userType === "superAdmin" ? formData.plantId : plantId };

		const {
			data: { error, message },
		} = updateData ? await handleUpdate(payload) : await handleAdd(payload);
		if (error) {
			toastMessage(false, message);
		} else {
			toastMessage(true, message);
			onUpdateSuccess();
			handleClose();
		}
	};
	const handleFormValidation = () => {
		let error = {};
		if (userDetail?.userType == "superAdmin" && !formData.orgId) error.orgId = "Organization name is required";
		if (!formData.plantId.length && userDetail?.userType == "superAdmin") error.plantId = "Warehouse is required";
		if (!formData.supplierName) error.supplierName = "Supplier name is required";
		if (!formData.supplierId) error.supplierId = "Supplier ID is required";

		if (Object.keys(error).length) {
			setError(error);
		} else {
			handleFormSubmit();
		}
	};
	const handleClose = () => {
		setFormData(defaultForm);
		onClose();
	};

	return (
		<Dialog size="xs" open={open} handleClose={handleClose} handleSubmit={handleFormValidation} title={updateData ? "Update Supplier" : "Add Supplier"} isSubmitDisabled={isAdding || isUpdating}>
			<form className="">
				<div className="form-inputs mt-2">
					{userDetail?.userType == "superAdmin" ? (
						<Dropdown id="orgId" name="orgId" label="Organization Name" onChange={onDropdownChange} options={orgOptions} value={orgValue} error={error.orgId} required />
					) : null}
					{userDetail?.userType == "superAdmin" ? (
						<Dropdown id="plantIdAdd" name="plantId" label="Warehouse" onChange={onDropdownChange} options={plantOptions} value={plantValue} required error={error.plantId} />
					) : null}
					<Input label="Supplier Name" placeholder="Enter Supplier Name" name="supplierName" value={formData.supplierName} onChange={handleInput} error={error.supplierName} required />
					<Input label="Supplier ID" placeholder="Enter Supplier ID" name="supplierId" value={formData.supplierId} onChange={handleInput} error={error.supplierId} required />
					<Input label="Prefix" placeholder="Enter Prefix" name="prefix" value={formData.prefix} onChange={handleInput} />
				</div>
			</form>
		</Dialog>
	);
}
